import "./styles.scss";

import { useTranslation } from "react-i18next";

function Tabs({ children, options, activeTab, setActiveTab }) {
  const { t } = useTranslation();

  return (
    <div className="tabs content">
      <ol className={`tab-list `}>
        <li className="tabsContent">
          {options.map((label, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(label)}
              className={`tab-list-item ${activeTab === label ? " tab-list-active" : ""}`}
            >
              {t(label.toUpperCase())}
            </button>
          ))}
        </li>
      </ol>
      <div className="tab-content">{children}</div>
    </div>
  );
}

export default Tabs;
